import React from 'react';
import styled from 'styled-components';
import { ContentStyleProps } from './models';
import * as styles from './styles';
import SubtitleV2 from '../onlineSubtitle/onlineSubtitle';
import TitleV2 from '../onlineTitle/Title';

export const ContentStyle = styled(
  ({ children, className, headerImage, title, subtitle, footer }: ContentStyleProps) => {
    return (
      <div {...{ className }}>
        {
          <div className="dynamic-popup-content">
            {headerImage && <img className="dynamic-popup-image" src={headerImage} />}
            {title && <TitleV2 className="dynamic-popup-title">{title}</TitleV2>}
            {subtitle && (
              <SubtitleV2 className="dynamic-popup-subtitle" alignLeft={false}>
                {subtitle}
              </SubtitleV2>
            )}
            {footer && <div className="dynamic-popup-footer">{footer}</div>}
          </div>
        }
      </div>
    );
  }
)`
  ${styles.ContentStyle}
`;
